








import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import KYCForm from '@company-common/model/kyc-form/KYCForm'
import { TableFormStructure } from '@master/model/structure/FormStructure'
import { YearsSupportMap, CustomDependant } from '@company-common/model/kyc-form/CustomDependant'
import { RelationshipOptions } from '@master/model/options/RelationshipOptions'
import AppFormTable from '@core/components/AppFormTable.vue'
import { GenderOptions } from '@master/model/options/GenderOptions'

const kycFormStore = namespace('KYCFormStore')

@Component({
  components: {
    AppFormTable
  }
})

export default class DependantsView extends Vue {
  @kycFormStore.State
  private kycForm!: KYCForm

  @kycFormStore.State
  private computedValidationResult: any

  get dependantsError () {
    const errors = this.computedValidationResult?.Dependants?.Common || []
    const finalErrors: { key: string; msg: string }[][] = []
    errors.map(({ key, message, index }) => {
      key.map(variableName => {
        if (!finalErrors[index - 1]) finalErrors[index - 1] = []
        finalErrors[index - 1].push({
          key: variableName,
          msg: message
        })
      })
    })
    return finalErrors
  }

  get yearSupportMap () {
    return YearsSupportMap
  }

  get dependants () {
    return this.kycForm?.dependants ?? []
  }

  get clientDeclaration () {
    return this.kycForm.clientDeclaration
  }

  get depColumns (): TableFormStructure<CustomDependant> {
    return [
      { label: 'Name (as per NRIC/FIN/Passport No.)', key: 'name', type: 'text' },
      { label: 'NRIC/FIN/Passport No.', key: 'nric', type: 'text' },
      {
        label: 'Date of Birth (dd/mm/yyyy)',
        type: 'date',
        disabledFutureDate: true,
        model: {
          get: (index) => {
            return this.dependants[index]?.dob ?? undefined
          },
          set: (index, value) => {
            if (this.dependants[index].relationship) {
              this.dependants[index].yearsSupport = '' // reset year to support so that it can take the default value
            }

            this.dependants[index].dob = value
          }
        }
      },
      {
        label: 'Age',
        key: 'age',
        type: 'number',
        disabled: true
      },
      {
        label: 'Relationship to Client',
        type: 'dropdown',
        options: RelationshipOptions,
        model: {
          get: (index) => {
            return this.dependants[index]?.relationship ?? ''
          },
          set: (index, value) => {
            if (this.dependants[index].age !== 0 && !this.dependants[index].age) {
              this.dependants[index].relationship = value
            } else if (this.dependants[index].relationship !== value) {
              this.dependants[index].yearsSupport = '' // reset year to support so that it can take the default value
            }
            this.dependants[index].relationship = value
          }
        }
      },
      { label: 'Gender', key: 'gender', type: 'dropdown', options: GenderOptions },
      {
        label: 'Years to support',
        key: 'customYearsSupport',
        type: 'number',
        onBlur: (index) => {
          if (this.dependants[index].yearsSupport !== this.dependants[index].defaultYearsSupport) {
            alert('Please explain deviation on Basis of Recommendation')
          }
        },
        tooltip: {
          content: this.getContent()
        }
      }
    ]
  }

  getContent () {
    let str = ''
    const excludeKeys = ['male', 'female']
    Object.keys(this.yearSupportMap).forEach(key => {
      if (!excludeKeys.includes(key)) {
        const relationship = this.yearSupportMap[key]
        str += relationship.label + ': to Age ' + relationship.year + ' <br/>'
      }
    })
    return str
  }

  setIfDeviationRequired () {
    const required = this.dependants.some(dependant => dependant.requiredDeviationExplanation)
    if (required) {
      this.kycForm.client1.recommendationBasis.productDeviationsExistence = 'yes'
    }
  }
}
